// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"8be716fd","223":"e6b14db0","239":"8145f56e","455":"10444f95","488":"144d1e14","516":"a899df3d","525":"c4c3c638","644":"d80d3bdf"}[chunkId] + ".chunk.js";
};